var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "justify-end": "" } },
    [
      _c(
        "v-btn",
        {
          staticClass: "mb-2",
          attrs: { slot: "activator", outline: "", color: "primary" },
          on: { click: _vm.open },
          slot: "activator"
        },
        [
          _c("v-icon", { attrs: { dark: "", left: "" } }, [_vm._v("note_add")]),
          _vm._v("New Item\n    ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "1000px", scrollable: "" },
          model: {
            value: _vm.localDialog,
            callback: function($$v) {
              _vm.localDialog = $$v
            },
            expression: "localDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.formTitle))
                ])
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-form",
                        { ref: "form" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("image-uploader", {
                                    attrs: {
                                      constImage: _vm.local.image,
                                      dialog: _vm.dialog,
                                      errorMsg: _vm.errorMsg
                                    },
                                    on: { image: _vm.assignImage }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Name",
                                      rules: _vm.generalRules,
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.local.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "name", $$v)
                                      },
                                      expression: "local.name"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.Animation,
                                      "item-text": function(item) {
                                        return _vm.Animation.name
                                      },
                                      "item-value": function(item) {
                                        return _vm.Animation.id
                                      },
                                      label: "Type of Animation",
                                      chips: "",
                                      "persistent-hint": ""
                                    },
                                    model: {
                                      value: _vm.local.typeOfAnimation,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local,
                                          "typeOfAnimation",
                                          $$v
                                        )
                                      },
                                      expression: "local.typeOfAnimation"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Genre" },
                                    model: {
                                      value: _vm.local.genre,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "genre", $$v)
                                      },
                                      expression: "local.genre"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Trim" },
                                    model: {
                                      value: _vm.local.trim,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "trim", $$v)
                                      },
                                      expression: "local.trim"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Blend" },
                                    model: {
                                      value: _vm.local.blend,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "blend", $$v)
                                      },
                                      expression: "local.blend"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Stich" },
                                    model: {
                                      value: _vm.local.stich,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "stich", $$v)
                                      },
                                      expression: "local.stich"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("h3", [_vm._v("Attachments")]),
                                  _vm._v(" "),
                                  _c(
                                    "file-uploader",
                                    {
                                      on: { input: _vm.assignFBX },
                                      model: {
                                        value: _vm.local.fbx,
                                        callback: function($$v) {
                                          _vm.$set(_vm.local, "fbx", $$v)
                                        },
                                        expression: "local.fbx"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "activator" },
                                          slot: "activator"
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Filmbox",
                                              readonly: "",
                                              "prepend-icon": "attach_file",
                                              rules: _vm.generalRules,
                                              required: ""
                                            },
                                            model: {
                                              value: _vm.local.fbx.fileName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.fbx,
                                                  "fileName",
                                                  $$v
                                                )
                                              },
                                              expression: "local.fbx.fileName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "file-uploader",
                                    {
                                      on: { input: _vm.assignIOS },
                                      model: {
                                        value: _vm.local.asset_bundle.iOS,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.local.asset_bundle,
                                            "iOS",
                                            $$v
                                          )
                                        },
                                        expression: "local.asset_bundle.iOS"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "activator" },
                                          slot: "activator"
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "iOS Asset Bundle",
                                              readonly: "",
                                              "prepend-icon": "attach_file",
                                              rules: _vm.generalRules,
                                              required: ""
                                            },
                                            model: {
                                              value:
                                                _vm.local.asset_bundle.iOS
                                                  .fileName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.asset_bundle.iOS,
                                                  "fileName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.asset_bundle.iOS.fileName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "file-uploader",
                                    {
                                      on: { input: _vm.assignAndroid },
                                      model: {
                                        value: _vm.local.asset_bundle.Android,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.local.asset_bundle,
                                            "Android",
                                            $$v
                                          )
                                        },
                                        expression: "local.asset_bundle.Android"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "activator" },
                                          slot: "activator"
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Android Asset Bundle",
                                              readonly: "",
                                              "prepend-icon": "attach_file",
                                              rules: _vm.generalRules,
                                              required: ""
                                            },
                                            model: {
                                              value:
                                                _vm.local.asset_bundle.Android
                                                  .fileName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.asset_bundle
                                                    .Android,
                                                  "fileName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.asset_bundle.Android.fileName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "file-uploader",
                                    {
                                      on: { input: _vm.assignWebGL },
                                      model: {
                                        value: _vm.local.asset_bundle.WebGL,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.local.asset_bundle,
                                            "WebGL",
                                            $$v
                                          )
                                        },
                                        expression: "local.asset_bundle.WebGL"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "activator" },
                                          slot: "activator"
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "WebGL Asset Bundle",
                                              readonly: "",
                                              "prepend-icon": "attach_file",
                                              rules: _vm.generalRules,
                                              required: ""
                                            },
                                            model: {
                                              value:
                                                _vm.local.asset_bundle.WebGL
                                                  .fileName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.asset_bundle.WebGL,
                                                  "fileName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.asset_bundle.WebGL.fileName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("h3", [_vm._v("Type of Rigs")]),
                                  _vm._v(" "),
                                  _c(
                                    "v-radio-group",
                                    {
                                      model: {
                                        value: _vm.local.rig,
                                        callback: function($$v) {
                                          _vm.$set(_vm.local, "rig", $$v)
                                        },
                                        expression: "local.rig"
                                      }
                                    },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.rigTypes.humanoid,
                                          value: _vm.rigTypes.humanoid
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.rigTypes.custom,
                                          value: _vm.rigTypes.custom
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("br")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c("v-divider", { attrs: { vertical: "" } }),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _vm.local.type === "Character"
                                    ? _c("div", [
                                        _c("h3", [
                                          _vm._v("Spectrum from Mixamo")
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.local.type === "Character"
                                    ? _c("v-select", {
                                        attrs: {
                                          items: _vm.Spectrum,
                                          "item-text": function(item) {
                                            return _vm.Spectrum.name
                                          },
                                          "item-value": function(item) {
                                            return _vm.Spectrum.id
                                          },
                                          label: "Select spectrum",
                                          chips: "",
                                          "persistent-hint": ""
                                        },
                                        model: {
                                          value: _vm.local.spectrum,
                                          callback: function($$v) {
                                            _vm.$set(_vm.local, "spectrum", $$v)
                                          },
                                          expression: "local.spectrum"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("h3", [_vm._v("Joints")]),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Interactive Joint" },
                                    model: {
                                      value: _vm.local.joint,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "joint", $$v)
                                      },
                                      expression: "local.joint"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("Dimension in meters")]),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Dimension X",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.local.dimension.X,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.local.dimension,
                                              "X",
                                              $$v
                                            )
                                          },
                                          expression: "local.dimension.X"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Dimension Y",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.local.dimension.Y,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.local.dimension,
                                              "Y",
                                              $$v
                                            )
                                          },
                                          expression: "local.dimension.Y"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Dimension Z",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.local.dimension.Z,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.local.dimension,
                                              "Z",
                                              $$v
                                            )
                                          },
                                          expression: "local.dimension.Z"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.Rotation,
                                      "item-text": function(item) {
                                        return _vm.Rotation.name
                                      },
                                      "item-value": function(item) {
                                        return _vm.Rotation.id
                                      },
                                      label: "Select rotation",
                                      chips: "",
                                      "persistent-hint": ""
                                    },
                                    model: {
                                      value: _vm.local.rotation,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "rotation", $$v)
                                      },
                                      expression: "local.rotation"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Number Of Loops",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.numberOfLoops,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local,
                                          "numberOfLoops",
                                          $$v
                                        )
                                      },
                                      expression: "local.numberOfLoops"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Duration (sec)",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.duration,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "duration", $$v)
                                      },
                                      expression: "local.duration"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.inverse_kinematics,
                                      "item-text": function(item) {
                                        return _vm.inverse_kinematics.name
                                      },
                                      "item-value": function(item) {
                                        return _vm.inverse_kinematics.id
                                      },
                                      label: "Select Inverse Kinematics",
                                      chips: "",
                                      "persistent-hint": ""
                                    },
                                    model: {
                                      value: _vm.local.inverseKinematics,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local,
                                          "inverseKinematics",
                                          $$v
                                        )
                                      },
                                      expression: "local.inverseKinematics"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("h3", [_vm._v("Position of Origin")]),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Dimension X",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.local.positionOfOrigin.X,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.local.positionOfOrigin,
                                              "X",
                                              $$v
                                            )
                                          },
                                          expression: "local.positionOfOrigin.X"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Dimension Y",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.local.positionOfOrigin.Y,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.local.positionOfOrigin,
                                              "Y",
                                              $$v
                                            )
                                          },
                                          expression: "local.positionOfOrigin.Y"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Dimension Z",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.local.positionOfOrigin.Z,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.local.positionOfOrigin,
                                              "Z",
                                              $$v
                                            )
                                          },
                                          expression: "local.positionOfOrigin.Z"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("h3", [_vm._v("Rotation of Origin")]),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Dimension X",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.local.rotationOfOrigin.X,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.local.rotationOfOrigin,
                                              "X",
                                              $$v
                                            )
                                          },
                                          expression: "local.rotationOfOrigin.X"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Dimension Y",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.local.rotationOfOrigin.Y,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.local.rotationOfOrigin,
                                              "Y",
                                              $$v
                                            )
                                          },
                                          expression: "local.rotationOfOrigin.Y"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Dimension Z",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.local.rotationOfOrigin.Z,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.local.rotationOfOrigin,
                                              "Z",
                                              $$v
                                            )
                                          },
                                          expression: "local.rotationOfOrigin.Z"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("br")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", outline: "" },
                      on: { click: _vm.close }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _vm.showSaveButton
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: { click: _vm.save }
                        },
                        [
                          this.saving
                            ? _c(
                                "v-flex",
                                [
                                  _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c("v-flex", [_vm._v("Save")])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78afd385", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78afd385","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/add-new/addCharacterAnimation.vue
// module id = null
// module chunks = 